import { useTranslation } from 'react-i18next';
import {
    ChatCircleIcon,
    PlugIcon,
    WebhooksLogoIcon,
    WhatsappLogoIcon,
} from '@phosphor-icons/react';
import type { Icon } from '@phosphor-icons/react';
import { I18nNamespace } from '@/lib/i18n-namespaces';
import { Chip } from '@/components';
import type { IntegrationStatus } from '@/types/admin-settings';

const INTEGRATION_ICONS: Record<string, Icon> = {
    slack: ChatCircleIcon,
    whatsapp: WhatsappLogoIcon,
    webhook: WebhooksLogoIcon,
};

interface IntegrationRowProps {
    integration: IntegrationStatus;
}

export function IntegrationRow({ integration }: IntegrationRowProps) {
    const { t } = useTranslation(I18nNamespace.SETTINGS);
    const IconComponent = INTEGRATION_ICONS[integration.key] ?? PlugIcon;

    return (
        <div className="flex items-center justify-between gap-3 border border-grey-600 rounded-[10px] p-4">
            <div className="flex items-center gap-3">
                <IconComponent className="size-5 text-grey-200" />
                <span className="text-sm text-grey-100">
                    {integration.name}
                </span>
            </div>
            <Chip
                value={
                    integration.configured
                        ? t('integrations.enabled')
                        : t('integrations.disabled')
                }
            />
        </div>
    );
}
